module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado.8be55f20.svg";